/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IMeasuresFormErrorState } from "../../../models/Roles/RolesContracts";
import { IMeasureGroup, IMeasures } from "../../../models/Policies/PolicyContract";
import {
  GET_ALL_MEASURES,
  GET_ALL_MEASURE_GROUP,
  SET_MEASURES_FORM_DATA,
  SET_POLICY_MEASURES_FORM_ERROR,
  UPDATE_POLICY_MEASURES_FORM_ERROR,
} from "./types";

export const getAllMeasuresAction = (measures?: IMeasures[] | undefined) => {
  return {
    type: GET_ALL_MEASURES,
    measures
  };
};

export const getAllMeasureGroupAction = (measureGroup?: IMeasureGroup[] | undefined) => {
  return {
    type: GET_ALL_MEASURE_GROUP,
    measureGroup
  };
};

export const setMeasuresPolicyFormData = (name: string, value: any) => {
  return {
    type: SET_MEASURES_FORM_DATA,
    data: {
      [name]: value
    }
  };
};

export const setMeasuresPolicyFormError = (errorData: IMeasuresFormErrorState) => {
  return {
    type: SET_POLICY_MEASURES_FORM_ERROR,
    errorData
  }
};

export const updateMeasuresPolicyFormError = (name: string, value: string | boolean) => {
  return {
    type: UPDATE_POLICY_MEASURES_FORM_ERROR,
    data: { [name]: value }
  }
};
